<template>
  <div class="container--large focus-video">
    <slot :openVideo="openVideo"/>
  </div>
</template>

<script>

  export default {
    name: 'focus-slider',

    methods: {
      getChildSlider() {
        let scrollSlider;
        [...this.$children].forEach((vueChildComponent) => {

          /* istanbul ignore else */
          if (vueChildComponent.$options._componentTag === 'scroll-slider') {
            scrollSlider = vueChildComponent;
          }
        });

        return scrollSlider;
      },

      openVideo(data, event) {
        this.getChildSlider().openVideo(data, event);
      }
    }
  };
</script>
